module.exports = "/_next/static/images/bottom-banner-app-633f6c6689ec72fe98f14787df530fcf.jpg";